module.exports = __webpack_public_path__ + "img/UTEAST-3.db126ac1.jpg";